import { render, staticRenderFns } from "./OmProposalFundingReport.vue?vue&type=template&id=1e7bf622&"
import script from "./OmProposalFundingReport.vue?vue&type=script&lang=js&"
export * from "./OmProposalFundingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports